// @flow
import { httpClient } from 'angieslist-app-platform';
import { defaultUpdateRequest } from '../../profile/common/profileService';

const updateBusinessDescription = (serviceProviderId: number, description: string): any =>
  httpClient.post(
    `/gateway/office-home/v1/service_provider/${serviceProviderId}/profile/edit`,
    {
      headers: { 'X-ANGI-CallerId': serviceProviderId },
      body: {
        ...defaultUpdateRequest,
        description: {
          action: 'Update',
          data: description,
        },
      },
    },
  );

/* eslint-disable import/prefer-default-export */
export { updateBusinessDescription };



// WEBPACK FOOTER //
// ./src/modules/home/common/welcomeService.js